module.exports = __webpack_public_path__ + "static/media/up_circle.d73125df.svg";